import { render, staticRenderFns } from "./visitpersons.vue?vue&type=template&id=174614ce&scoped=true&"
import script from "./visitpersons.vue?vue&type=script&lang=js&"
export * from "./visitpersons.vue?vue&type=script&lang=js&"
import style0 from "./visitpersons.vue?vue&type=style&index=0&id=174614ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174614ce",
  null
  
)

export default component.exports